import React from "react";
import PortfolioChart from "../PortfolioChart/PortfolioChart";
import Big from "big.js";
import { connect } from "react-redux";
import { TReducers } from "@features/reducers";
import IMyEquityCompanies, { IEquityCompany } from "./IMyEquityCompanies";
import HeldCompanies from "@portfolio/components/HeldCompanies/HeldCompanies";
import { hasActiveAssets } from "@portfolio/features/helpers.portfolio";

import * as style from "./MyEquityCompaniesStyle.module.scss";
import * as pages from "@appStyles/pages.module.scss";

export const MyEquityCompanies: React.FunctionComponent<IMyEquityCompanies> = (
  props
) => {
  const sortEquitiesByValue = (companies: IEquityCompany[]) => [
    ...companies.sort((a: IEquityCompany, b: IEquityCompany) =>
      Number(Big(b.equity.value).minus(a.equity.value).toString())
    ),
  ];

  const myEquityCompany = (companies: IEquityCompany[]) =>
    companies.filter(
      (company) => company.spv && hasActiveAssets(company.spv.assets)
    );

  const companiesToDisplay = (companies: IEquityCompany[]) => {
    const sortedEquites = sortEquitiesByValue(myEquityCompany(companies));

    if (sortedEquites.length === 0) return sortEquitiesByValue(companies);

    return sortedEquites;
  };

  return (
    <div id="myequitycompany" className={style.myEquityCompanies}>
      <div>
        <h1 className={`${pages.header} nostyle`}>Equity capital</h1>
        <div className={style.equityWrapper}>
          {props.equityCompanies.length > 0 && (
            <>
              <HeldCompanies
                companies={companiesToDisplay(props.equityCompanies)}
              />
              <div>
                <PortfolioChart
                  equityCompanies={companiesToDisplay(props.equityCompanies)}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (store: TReducers) => ({
  equityCompanies: store.portfolioReducer.companies.filter(
    (company) =>
      company.equity &&
      company.equity.value &&
      company.details &&
      company.details.name
  ),
});

export default connect(mapStateToProps)(MyEquityCompanies);
